import { Modal, ModalBody } from "reactstrap";
import ButtonUtility from "../../Components/Buttons/Utility";
import { GenericCarousel } from "../../Components/Carousel/Carousel";
import { createModalConfig, ModalConfig } from "../../Models/ModalConfig";
import { useCallback, useState } from "react";
import ZPLViewer from "../../Components/common/ZPLViewer";
import { useAppContext } from "../../AppProvider";
import { Attachment } from "../../Models/Attachment";
import { AttachmentCard } from "./AttachmentCard";
import { faImageSlash, faLoader } from "../../utilities/fontawesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDetailsIndexContext } from "../Shipments/providers/hooks";
import { useAttachmentsIndexContext } from "./providers/hooks";
import { Shipment } from "../../Models/Shipment";

export const AttachmentIndex: React.FC = () => {
  const context = useAttachmentsIndexContext();
  const { data, loader, modalConfig, setModalConfig } = context;
  const { data: shipment } = useDetailsIndexContext();
  const [ddtEnabled, setDdtEnabled] = useState(true);
  const { dictionary } = useAppContext();

  const openModal = useCallback(
    (
      action: ModalConfig["action"],
      data: string[] | Attachment[],
      size: ModalConfig["size"] = "sm",
      className = "",
      title = "",
    ) => {
      context?.setModalConfig({
        isOpen: true,
        action,
        size,
        data,
        className,
        title,
      });
    },
    [context],
  );

  const closeModal = () => {
    if (setModalConfig) {
      setModalConfig(createModalConfig());
    }
  };

  return (
    <>
      <Modal isOpen={modalConfig?.isOpen} size={modalConfig?.size}>
        <ModalBody className={modalConfig?.className || ""}>
          <h3 className="text-center mb-3">{modalConfig.title}</h3>
          {/* {modalConfig.action === "zpl" && shipment && (
            <>
              <ZPLViewer
                reference={
                  shipment.carrierReference || shipment.internalReference
                }
                url={modalConfig?.data?.[0]?.url || ""}
                // callback={closeModal}
                ddtEnabled={ddtEnabled}
                shipmentId={shipment.id || ""}
                setDdtEnabled={setDdtEnabled}
              />
              <ButtonUtility
                className="w-100"
                onClick={() => closeModal()}
                disabled={loader}
              >
                {dictionary.words.back}
              </ButtonUtility>
            </>
          )} */}

          {modalConfig.action === "viewAll" && (
            <div className="row g-3">
              {data.map((item) => (
                <div key={item?.id} className="col-12 col-sm-6 col-xl-4">
                  <div className="border rounded p-3">
                    {item && (
                      <AttachmentCard
                        item={item}
                        ddtEnabled={ddtEnabled}
                        setDdtEnabled={setDdtEnabled}
                        openModal={openModal}
                        shipment={shipment as Shipment}
                      />
                    )}
                  </div>
                </div>
              ))}
              <div className="d-flex justify-content-end">
                <ButtonUtility
                  className="w-100 w-lg-25"
                  onClick={() => closeModal()}
                  disabled={loader}
                >
                  {dictionary.words.back}
                </ButtonUtility>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>

      {!data || data.length === 0 ? (
        <>
          <div className="w-100 d-flex justify-content-center align-items-center">
            <FontAwesomeIcon icon={faImageSlash} color="#bbb" size="8x" />
          </div>
        </>
      ) : (
        <>
          {loader ? (
            <>
              <div className="d-flex align-items-center justify-content-center h-100">
                <FontAwesomeIcon icon={faLoader} spin size="2x" />
              </div>
            </>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center w-100">
              <GenericCarousel
                id="attachmentCarousel"
                data={data as Attachment[]}
                renderItem={(item) => (
                  <div key={item?.id}>
                    {item && (
                      <AttachmentCard
                        item={item}
                        ddtEnabled={ddtEnabled}
                        setDdtEnabled={setDdtEnabled}
                        openModal={openModal}
                        shipment={shipment as Shipment}
                      />
                    )}
                  </div>
                )}
              />
              {data && data?.length > 1 && (
                <ButtonUtility
                  className="w-100 mt-5 bg-black text-white rounded-2"
                  onClick={() =>
                    openModal(
                      "viewAll",
                      data as Attachment[],
                      "lg",
                      "",
                      `  ${dictionary.words.labels} ${dictionary.words.and} ${dictionary.words.documents}`,
                    )
                  }
                >
                  {dictionary.actions.view} {dictionary.words.all_s}
                </ButtonUtility>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};
